import { useUnleashClient } from "@unleash/proxy-client-react";

const useUnleashFlag = () => {
  const unleashClient = useUnleashClient();

  const hasAccessOfUnleashFlag = (flagName: string) => {
    return unleashClient.isEnabled(flagName);
  };

  return {
    hasAccessOfUnleashFlag,
  };
};

export default useUnleashFlag;
